import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-151"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M15.605 6.634a.412.412 0 0 0-.109.015 4.127 4.127 0 0 1-1.082.145 4.303 4.303 0 0 1-1.424-.248 4.276 4.276 0 0 1-2.725-5.086A.388.388 0 0 0 9.9.972a.374.374 0 0 0-.14.027A4.772 4.772 0 0 0 6.779 5.72c.007.12.038.233.055.35a5.29 5.29 0 0 1 .667-.045c.113 0 .224.012.336.02a3.562 3.562 0 0 1-.06-.384 3.782 3.782 0 0 1 1.357-3.138 5.405 5.405 0 0 0 .262 1.629A5.25 5.25 0 0 0 12.66 7.49a5.315 5.315 0 0 0 1.754.304h.047a3.788 3.788 0 0 1-.886.771 3.793 3.793 0 0 1 .874.622 4.774 4.774 0 0 0 1.525-2.037.384.384 0 0 0-.37-.516z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M11.815 8.71a3.138 3.138 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.136 3.136 0 0 0-.397-.04 3.184 3.184 0 1 0 1.244 6.117 4.61 4.61 0 0 0 6.144 0 3.185 3.185 0 1 0 1.244-6.116zm0 5.37a2.17 2.17 0 0 1-.852-.173 1 1 0 0 0-1.05.168 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.168 2.185 2.185 0 1 1-.853-4.196 1.227 1.227 0 0 1 .17.018l.102.014a1 1 0 0 0 .962-.444 3.675 3.675 0 0 1 6.164 0 1 1 0 0 0 .962.444l.102-.014a1.228 1.228 0 0 1 .17-.018 2.184 2.184 0 1 1 0 4.369z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }